export default __webpack_public_path__ + "static/media/forestly-noexpl-base_DE.2837c28c.png";